/**
 * @file Account setup container.
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { graphql } from 'react-apollo';
import compose from 'lodash.flowright';
import { withRouter } from 'react-router-dom';
import qs from 'query-string';

import {
  passwordResetRequest,
  passwordReset,
} from '../../graphql/mutations/account';
import PasswordResetRequestForm from '../../components/auth/PasswordResetRequestForm';
import PasswordResetForm from '../../components/auth/PasswordResetForm';

class PasswordReset extends Component {
  static propTypes = {
    resetPasswordRequest: PropTypes.func.isRequired,
    resetPassword: PropTypes.func.isRequired,
    location: PropTypes.shape({
      search: PropTypes.string,
    }),
    staticContext: PropTypes.shape({
      token: PropTypes.string,
    }),
  };

  getTokenFromUrl() {
    const { staticContext, location } = this.props;

    if (staticContext && staticContext.query.token) {
      return staticContext.query.token;
    }

    const parsed = qs.parse(location.search);
    return parsed.token;
  }

  render() {
    const token = this.getTokenFromUrl();

    return token ? (
      <PasswordResetForm
        resetPassword={this.props.resetPassword}
        token={token}
      />
    ) : (
      <PasswordResetRequestForm
        resetPasswordRequest={this.props.resetPasswordRequest}
      />
    );
  }
}

const withPasswordResetRequestMutation = graphql(passwordResetRequest, {
  props: ({ mutate }) => ({
    resetPasswordRequest: email =>
      mutate({
        variables: {
          input: {
            email_address: email,
          },
        },
      }),
  }),
});

const withPasswordResetMutation = graphql(passwordReset, {
  props: ({ mutate }) => ({
    resetPassword: (token, password) =>
      mutate({
        variables: {
          input: {
            token,
            new_password: password,
          },
        },
      }),
  }),
});

export { PasswordReset };

export default compose(
  withPasswordResetRequestMutation,
  withPasswordResetMutation,
  withRouter,
)(PasswordReset);
